(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ExpenseTypeDetailController', ExpenseTypeDetailController);

    ExpenseTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'ExpenseType'];

    function ExpenseTypeDetailController($scope, $rootScope, $stateParams, entity, ExpenseType) {
        var vm = this;
        vm.expenseType = entity;
        vm.load = function (id) {
            ExpenseType.get({id: id}, function(result) {
                vm.expenseType = result;
            });
        };
        var unsubscribe = $rootScope.$on('wamasysApp:expenseTypeUpdate', function(event, result) {
            vm.expenseType = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
